<template>
  <div>
    <exo-form hideClose :root="_self" :clear="false">
      <template v-slot:titleTooltip>
        <exo-help-dialog
          :color="'black--text'"
          :margin="'m-0'"
          title="Constellation Optimization"
        >
          <tooltipConstellationOptimizationMission />
        </exo-help-dialog>
      </template>
      <exo-input-name :root="_self" />
      <v-row no-gutters>
        <v-col cols="6">
          <v-row>
            <v-col>
              <exo-card-form label="Optimisation">
                <!--exo-input-select :root="_self" name="optimizerType">
                  <exo-help-dialog title="Optimizer type">
                    The constellation optimisation mission can be performed with different optimisation algorithms:
                    <ul>
                      <li>Grid-search algorithm.</li>
                      <li>Genetic algorithm.</li>
                    </ul>
                  </exo-help-dialog>
                </exo-input-select-->
                <exo-input-select :root="_self" name="optimizationGoal">
                  <exo-help-dialog title="Optimisation goal">
                    <tooltipConstellationOptimisationGoals />
                  </exo-help-dialog>
                </exo-input-select>
                <div v-if="inputs.optimizationGoal == 'CUSTOM'">
                  <h4>Cost function weights</h4>
                  <v-col cols="11">
                    <v-row>
                      <v-col>
                        <exo-input-double
                          :root="_self"
                          name="numberOfPlanesCostWeight"
                        />
                      </v-col>
                      <v-col>
                        <exo-input-double
                          :root="_self"
                          name="numberOfSpacecraftCostWeight"
                        />
                      </v-col>
                      <v-col>
                        <exo-input-double
                          :root="_self"
                          name="semiMajorAxisCostWeight"
                        />
                      </v-col>
                      <v-col>
                        <exo-input-double
                          :root="_self"
                          name="avgPointRevisitTimeCostWeight"
                        />
                      </v-col>
                      <v-col>
                        <exo-input-double
                          :root="_self"
                          name="maxPointRevisitTimeCostWeight"
                        />
                      </v-col>
                    </v-row>
                    <exo-form-alert
                      type="warning"
                      v-if="
                        inputs.optimizationGoal == 'CUSTOM' &&
                        inputs.numberOfSpacecraftCostWeight == 0 &&
                        inputs.numberOfPlanesCostWeight == 0 &&
                        inputs.maxPointRevisitTimeCostWeight == 0 &&
                        inputs.avgPointRevisitTimeCostWeight == 0 &&
                        inputs.semiMajorAxisCostWeight == 0
                      "
                    >
                      One of the weights should be greater than zero.
                    </exo-form-alert>
                  </v-col>
                </div>
                <exo-input-double
                  :root="_self"
                  name="maxAllowedPointRevisitTime"
                />
                <exo-input-ref-notparametric
                  :root="_self"
                  name="zoneOfInterest"
                  type="zoneOfInterest"
                  componentRoute="/analyticalconstellationearthzoneofinterest"
                />
                <exo-input-ref-notparametric
                  :root="_self"
                  name="initialConstellation"
                  type="constellation"
                  componentRoute="/analyticalconstellationheterogeneous"
                >
                  <exo-help-dialog title="Constellation">
                    <tooltipConstellationGeometry />
                  </exo-help-dialog>
                </exo-input-ref-notparametric>
                <exo-form-alert
                  class="mb-2"
                  type="warning"
                  v-if="missingPayload"
                >
                  A payload has to be defined in the constellation.
                </exo-form-alert>
                <exo-form-alert
                  class="mb-2"
                  type="warning"
                  v-if="missingSpacecraftOrDragModel"
                >
                  A spacecraft with a drag model has to be defined in the
                  constellation.
                </exo-form-alert>
                <exo-input-date-time :root="_self" name="simulationDate">
                  <exo-help-dialog margin="mt-1 ml-2" title="Simulation date">
                    The simulation date is used as reference for the definition
                    of the RAAN / MLTAN of each planes of the constellation. It
                    is used also to compute the Sun position if the sunlight is
                    considered.
                  </exo-help-dialog>
                </exo-input-date-time>
              </exo-card-form>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="6">
          <v-row>
            <v-col>
              <exo-card-form label="Metrics computation">
                <exo-input-double :root="_self" name="filterRatio">
                  <exo-help-dialog title="Custom percentile">
                    <tooltipCustomPercentile />
                  </exo-help-dialog>
                </exo-input-double>
                <exo-input-checkbox :root="_self" name="sunLightConsidered">
                  <exo-help-dialog
                    margin="mb-3 ml-2"
                    alignWithParametricField
                    title="Use Sun light for payload visibility"
                  >
                    The sunlight can be taken into account in the performance
                    metrics computation by defining an enlightenment condition.
                  </exo-help-dialog>
                </exo-input-checkbox>
                <exo-input-double
                  v-if="inputs.sunLightConsidered"
                  :root="_self"
                  name="sunZenithAngle"
                >
                  <exo-help-dialog title="Sun zenith angle">
                    <tooltipSunZenithAngle />
                  </exo-help-dialog>
                </exo-input-double>
                <exo-input-checkbox
                  :root="_self"
                  name="reconfigurationDeltaVNeeded"
                >
                  <exo-help-dialog
                    margin="mt-1 ml-2"
                    title="Compute the maximum deltaV for reconfiguration"
                  >
                    The maximum deltaV applied by spacecrafts for
                    reconfiguration is computed, based on the required
                    variations of altitude, inclination and raan.
                  </exo-help-dialog>
                </exo-input-checkbox>
                <exo-input-double
                  v-if="inputs.reconfigurationDeltaVNeeded"
                  :root="_self"
                  name="maneuverDuration"
                >
                  <exo-help-dialog title="Maneuver Duration">
                    This is the duration for a spacecraft to perform its
                    maneuver to reach its final orbit
                  </exo-help-dialog>
                </exo-input-double>
                <exo-input-checkbox
                  :root="_self"
                  name="customOptimizationParameters"
                >
                  <exo-help-dialog
                    margin="mb-1 ml-2"
                    title="Customised genetic algorithm parameters"
                  >
                    <tooltipConstellationGeneticOptimisationParameters />
                  </exo-help-dialog>
                </exo-input-checkbox>
              </exo-card-form>

              <div v-if="inputs.customOptimizationParameters">
                <exo-card-form label="Genetic algorithm options">
                  <v-row no-gutters>
                    <v-col cols="6">
                      <exo-input-double :root="_self" name="lambda" />
                    </v-col>
                    <v-col cols="6">
                      <exo-input-double :root="_self" name="mu" />
                    </v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col cols="6">
                      <exo-input-double
                        :root="_self"
                        name="maximumPhenotypeAge"
                      />
                    </v-col>
                    <v-col cols="6">
                      <exo-input-double
                        :root="_self"
                        name="mutationProbability"
                      />
                    </v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col cols="4">
                      <exo-input-double
                        :root="_self"
                        name="steadyFitnessNumber"
                      />
                    </v-col>
                    <v-col cols="4">
                      <exo-input-double
                        :root="_self"
                        name="maximumGenerations"
                      />
                    </v-col>
                    <v-col cols="4">
                      <exo-input-double :root="_self" name="maximumDuration" />
                    </v-col>
                  </v-row>
                </exo-card-form>
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <exo-card-form
            v-if="displayBounds"
            label="Optimisation variables bounds"
          >
            <v-data-table
              :headers="boundsTableHeaders"
              :items="boundsTableItems"
              :footer-props="{ itemsPerPageOptions: rowsPerPageItems }"
              :options.sync="pagination"
              style="overflow: auto"
            >
              <template
                v-for="h in boundsTableHeaders"
                v-slot:[`header.${h.value}`]
              >
                <div :key="h.value">
                  <div slot="activator"></div>
                  <div>
                    <span>{{ h.text }}</span>
                  </div>
                </div>
              </template>
              <template slot="item" slot-scope="row">
                <tr>
                  <td
                    class="px-1 text-right"
                    v-for="(header, headerIndex) in boundsTableHeaders"
                    :key="headerIndex"
                  >
                    <div>
                      <div class="text-left" v-if="headerIndex === 0">
                        {{ displayGeometryName(row) }}
                      </div>
                      <tr>
                        <td v-if="headerIndex == 1" class="mt-2 mb-1" cols="12">
                          <tr>
                            <td cols="12">
                              <v-text-field
                                horizontal
                                class="ml-2"
                                v-model="row.item.negativeDeltaAltitude"
                                flat
                                filled
                                dense
                                :rules="[rules.validAltitudeDecrease]"
                                prefix="-"
                              >
                              </v-text-field>
                              <v-text-field
                                horizontal
                                class="ml-2"
                                v-model="row.item.positiveDeltaAltitude"
                                flat
                                filled
                                dense
                                :rules="[rules.validAltitudeIncrease]"
                                prefix="+"
                              >
                              </v-text-field>
                            </td>
                          </tr>
                        </td>
                        <v-col
                          v-if="headerIndex == 2"
                          class="mt-2 mb-1"
                          cols="12"
                        >
                          <v-row>
                            <v-col cols="12">
                              <v-text-field
                                horizontal
                                class="ml-2"
                                v-model="row.item.negativeDeltaInclination"
                                flat
                                filled
                                dense
                                :rules="[rules.validInclinationDecrease]"
                                prefix="-"
                              >
                              </v-text-field>
                              <v-text-field
                                horizontal
                                class="ml-2"
                                v-model="row.item.positiveDeltaInclination"
                                flat
                                filled
                                dense
                                :rules="[rules.validInclinationIncrease]"
                                prefix="+"
                              >
                              </v-text-field>
                            </v-col>
                          </v-row>
                        </v-col>
                        <v-col
                          v-if="headerIndex == 3"
                          class="mt-2 mb-1"
                          cols="12"
                        >
                          <v-row>
                            <v-col cols="12">
                              <v-text-field
                                horizontal
                                class="ml-2"
                                v-model="
                                  row.item.negativeDeltaInterPlanePhasing
                                "
                                flat
                                filled
                                dense
                                :rules="[rules.validInterPlanePhasingDecrease]"
                                prefix="-"
                                :disabled="hasOnlyOnePlane(row.index)"
                              >
                              </v-text-field>
                              <v-text-field
                                horizontal
                                class="ml-2"
                                v-model="
                                  row.item.positiveDeltaInterPlanePhasing
                                "
                                flat
                                filled
                                dense
                                :rules="[rules.validInterPlanePhasingIncrease]"
                                prefix="+"
                                :disabled="hasOnlyOnePlane(row.index)"
                              >
                              </v-text-field>
                            </v-col>
                          </v-row>
                        </v-col>
                        <v-col v-if="headerIndex == 4" class="mt-2 mb-1">
                          <v-row>
                            <v-col>
                              <v-text-field
                                horizontal
                                class="ml-2"
                                v-model="row.item.negativeRaanShift"
                                flat
                                filled
                                dense
                                :rules="[rules.validRaanDecrease]"
                                prefix="-"
                              >
                              </v-text-field>
                              <v-text-field
                                horizontal
                                class="ml-2"
                                v-model="row.item.positiveRaanShift"
                                flat
                                filled
                                dense
                                :rules="[rules.validRaanIncrease]"
                                prefix="+"
                              >
                              </v-text-field>
                            </v-col>
                          </v-row>
                        </v-col>
                        <v-col
                          v-if="headerIndex == 5"
                          class="mt-2 mb-1"
                          cols="12"
                        >
                          <v-row>
                            <v-col cols="12">
                              <v-text-field
                                horizontal
                                class="ml-2"
                                v-model="row.item.negativeDeltaNumberOfPlanes"
                                type="number"
                                min="0"
                                flat
                                filled
                                dense
                                :rules="[rules.validNumberOfPlanesDecrease]"
                                prefix="-"
                              >
                              </v-text-field>
                              <v-text-field
                                horizontal
                                class="ml-2"
                                v-model="row.item.positiveDeltaNumberOfPlanes"
                                type="number"
                                min="0"
                                flat
                                filled
                                dense
                                :rules="[rules.validNumberOfPlanesIncrease]"
                                prefix="+"
                              >
                              </v-text-field>
                            </v-col>
                          </v-row>
                        </v-col>
                        <v-col
                          v-if="headerIndex == 6"
                          class="mt-2 mb-1"
                          cols="12"
                        >
                          <v-row>
                            <v-col cols="12">
                              <v-text-field
                                horizontal
                                class="ml-2"
                                v-model="
                                  row.item
                                    .negativeDeltaNumberOfSpacecraftsPerPlane
                                "
                                type="number"
                                min="0"
                                flat
                                filled
                                dense
                                :rules="[
                                  rules.validNumberOfSpacecraftsPerPlaneDecrease
                                ]"
                                prefix="-"
                              >
                              </v-text-field>
                              <v-text-field
                                horizontal
                                class="ml-2"
                                v-model="
                                  row.item
                                    .positiveDeltaNumberOfSpacecraftsPerPlane
                                "
                                type="number"
                                min="0"
                                flat
                                filled
                                dense
                                :rules="[
                                  rules.validNumberOfSpacecraftsPerPlaneIncrease
                                ]"
                                prefix="+"
                              >
                              </v-text-field>
                            </v-col>
                          </v-row>
                        </v-col>
                      </tr>
                    </div>
                  </td>
                </tr>
              </template>
            </v-data-table>
            <exo-form-alert
              class="mb-2"
              type="info"
              v-if="showNewPlanesRaanMessage"
            >
              Newly added planes can have their RAAN placed anywhere between
              -180 and 180 degrees.
            </exo-form-alert>
            <exo-form-alert
              class="mb-2"
              type="info"
              v-if="onlyOnePlaneMessage != ''"
            >
              {{ onlyOnePlaneMessage }}
            </exo-form-alert>
          </exo-card-form>
        </v-col>
      </v-row>
    </exo-form>
  </div>
</template>

<script>
import formMixin from '../../mixins/forms.js'
import formAnalyticalMixin from '../../mixins/analyticalFoms.js'
import constellationComponentsLoader from '../../components/Forms/analyticalConstellationsComponents.js'
import dataTools from '../../tools/data.js'
import missionTools from '../../store/mission.js'
import fieldsDescription from '../../tools/fieldsDescription.json'
import dataDescription from '../../tools/dataDescription.json'
import { mapGetters, mapActions } from 'vuex'
import tooltipSunZenithAngle from '../../components/Tooltips/ConstellationModule/tooltipSunZenithAngle'
import tooltipConstellationGeometry from '../../components/Tooltips/ConstellationModule/tooltipConstellationGeometry'
import tooltipCustomPercentile from '../../components/Tooltips/ConstellationModule/tooltipCustomPercentile'
import tooltipConstellationOptimizationMission from '../../components/Tooltips/ConstellationModule/tooltipConstellationOptimizationMission'
import tooltipConstellationOptimisationGoals from '../../components/Tooltips/ConstellationModule/tooltipConstellationOptimisationGoals'
import tooltipConstellationGeneticOptimisationParameters from '../../components/Tooltips/ConstellationModule/tooltipConstellationGeneticOptimisationParameters'

constellationComponentsLoader()

export default {
  name: 'ConstellationRevisitOptimizationMission',

  mixins: [formMixin, formAnalyticalMixin],

  components: {
    tooltipSunZenithAngle,
    tooltipConstellationGeometry,
    tooltipCustomPercentile,
    tooltipConstellationOptimizationMission,
    tooltipConstellationOptimisationGoals,
    tooltipConstellationGeneticOptimisationParameters
  },

  async mounted() {
    this.$root.$on(
      'request-computation-constellation-optimization',
      this.requestComputationConstellationOptimizationHandler
    )
    this.$root.$on('copy-mission', this.copyMissionHandler)
    this.$root.$on('create-mission', this.createMissionHandler)
    this.$root.$on('current-mission-updated', this.currentMissionUpdatedHandler)
    await this.refreshReferences()
    this.refreshForm()
  },

  beforeDestroy() {
    this.$root.$off(
      'request-computation-constellation-optimization',
      this.requestComputationConstellationOptimizationHandler
    )
    this.$root.$off('copy-mission', this.copyMissionHandler)
    this.$root.$off('create-mission', this.createMissionHandler)
    this.$root.$off(
      'current-mission-updated',
      this.currentMissionUpdatedHandler
    )
  },

  computed: {
    ...mapGetters(['currentMission']),

    displayRequirementsErrorMessage() {
      if (!this.currentMission) {
        return 'Outdated data, please refresh your page our logout and login after'
      }
      if (!this.inputs.initialConstellation) {
        return 'Please select a constellation'
      }
      if (
        !this.inputs.initialConstellation.homogeneousConstellationGeometries
      ) {
        return 'Please define at least one geometry in your constellation'
      }
      return ''
    },

    displayRequirements() {
      return this.displayRequirementsErrorMessage === ''
    },

    displayBounds() {
      if (this.inputs.initialConstellation) {
        this.setBoundsTable()
      }
      return this.displayRequirements
    },

    boundsTableHeaders() {
      let headers = []
      headers.push({ text: 'Geometry', value: 'firstColumn', sortable: false })
      headers.push({
        text: 'Altitude variations' + ' (km)',
        value: 'altitudeColumn',
        sortable: false
      })
      headers.push({
        text: 'Inclination variations' + ' (deg)',
        value: 'inclinationColumn',
        sortable: false
      })
      headers.push({
        text: 'Inter-plane phasing variations' + ' (deg)',
        value: 'interPlanePhasingColumn',
        sortable: false
      })
      headers.push({
        text: 'RAANs variations' + ' (deg)',
        value: 'raansColumn',
        sortable: false
      })
      headers.push({
        text: 'Number of planes variations',
        value: 'numberOfPlanesColumn',
        sortable: false
      })
      headers.push({
        text: 'Number of spacecrafts per plane variations',
        value: 'numberOfSpacecraftsPerPlaneColumn',
        sortable: false
      })
      return headers
    },

    boundsTableItems() {
      let items = []
      if (this.inputs.geometriesBounds != null) {
        for (let geometryBounds of this.inputs.geometriesBounds) {
          items.push(geometryBounds)
        }
      }
      return items
    },

    groundSegmentEphemeridesEvaluation() {
      return this.inputs.computeExtendedGroundSegment === true
    },
    groundSegmentEvaluation() {
      return (
        this.inputs.computeSimplifiedGroundSegment === true ||
        this.inputs.computeExtendedGroundSegment === true
      )
    },

    missingSpacecraftOrDragModel() {
      if (this.inputs.reconfigurationDeltaVNeeded) {
        if (this.inputs.initialConstellation) {
          if (
            this.inputs.initialConstellation
              .homogeneousConstellationGeometries[0]
          ) {
            if (
              !this.inputs.initialConstellation
                .homogeneousConstellationGeometries[0].spacecraft
            ) {
              return true
            }
            if (
              this.inputs.initialConstellation
                .homogeneousConstellationGeometries[0].spacecraft
                ?.dragModelDefined === false
            ) {
              return true
            }
          }
        }
      }
      return false
    },

    missingPayload() {
      if (this.inputs.initialConstellation) {
        if (
          this.inputs.initialConstellation.homogeneousConstellationGeometries[0]
        ) {
          if (
            !this.inputs.initialConstellation
              .homogeneousConstellationGeometries[0].payload
          ) {
            return true
          }
        }
      }
      return false
    },

    inputsValid() {
      let fieldsState = this.verifyPropertiesList(
        this.getRequiredPropertiesList(this.inputs),
        this.inputs,
        true
      )
      fieldsState =
        fieldsState &&
        this.verifyPropertiesList(
          this.getOptionalPropertiesList(this.inputs),
          this.inputs,
          false
        )
      return this.inputNameState && fieldsState && !this.missingPayload
    },

    showNewPlanesRaanMessage() {
      let showMessage = false
      if (this.inputs.geometriesBounds) {
        for (let bounds of this.inputs.geometriesBounds) {
          if (bounds.positiveDeltaNumberOfPlanes > 0) {
            showMessage = true
          }
        }
      }
      return showMessage
    },

    onlyOnePlaneMessage() {
      let onePlaneGeometries = []
      let message = ''
      if (this.inputs.initialConstellation) {
        for (let geometryIndex in this.inputs.initialConstellation
          .homogeneousConstellationGeometries) {
          if (this.hasOnlyOnePlane(geometryIndex)) {
            onePlaneGeometries.push(
              this.inputs.initialConstellation
                .homogeneousConstellationGeometries[geometryIndex].name
            )
          }
        }
      }

      if (onePlaneGeometries.length === 0) {
        return message
      } else if (onePlaneGeometries.length === 1) {
        message += 'The geometry "' + onePlaneGeometries[0] + '" has '
      } else if (onePlaneGeometries.length > 1) {
        message += 'The geometries "'
        for (let geometryIndex in onePlaneGeometries) {
          if (geometryIndex < onePlaneGeometries.length - 2) {
            message += onePlaneGeometries[geometryIndex] + '", "'
          } else if (geometryIndex == onePlaneGeometries.length - 2) {
            message += onePlaneGeometries[geometryIndex] + '" and "'
          } else {
            message += onePlaneGeometries[geometryIndex]
          }
        }
        message += '" have '
      }
      message +=
        'only one plane, thus the inter-plane phasing angle is not defined. Newly added planes will define an inter-plane phasing angle anywhere between -180 and  180 degrees.'
      return message
    }
  },

  data() {
    return {
      tableFields: [],
      rowsPerPageItems: [20, 50, { text: 'All', value: -1 }],
      pagination: {
        rowsPerPage: -1
      },

      enumPropertiesList: this.getEnumProperties(),

      modalRef: { content: [] },
      showModal: false,

      constellationsNotParametrics: [],
      groundStationsNotParametrics: [],
      zoneOfInterestsNotParametrics: [],

      rules: {
        validAltitudeDecrease: (value) =>
          (dataTools.isNumber(value) && value >= 0) ||
          'Positive number expected',
        validAltitudeIncrease: (value) =>
          (dataTools.isNumber(value) && value >= 0) ||
          'Positive number expected',
        validInclinationDecrease: (value) =>
          (dataTools.isNumber(value) && value >= 0) ||
          'Positive number expected',
        validInclinationIncrease: (value) =>
          (dataTools.isNumber(value) && value >= 0) ||
          'Positive number expected',
        validNumberOfPlanesDecrease: (value) =>
          (Number.isInteger(Number(value)) && value >= 0) ||
          'Positive number expected',
        validNumberOfPlanesIncrease: (value) =>
          (Number.isInteger(Number(value)) && value >= 0) ||
          'Positive number expected',
        validNumberOfSpacecraftsPerPlaneDecrease: (value) =>
          (Number.isInteger(Number(value)) && value >= 0) ||
          'Positive number expected',
        validNumberOfSpacecraftsPerPlaneIncrease: (value) =>
          (Number.isInteger(Number(value)) && value >= 0) ||
          'Positive number expected',
        validRaanDecrease: (value) =>
          (dataTools.isNumber(value) && value >= 0) ||
          'Positive number expected',
        validRaanIncrease: (value) =>
          (dataTools.isNumber(value) && value >= 0) ||
          'Positive number expected',
        validInterPlanePhasingDecrease: (value) =>
          (dataTools.isNumber(value) && value >= 0) ||
          'Positive number expected',
        validInterPlanePhasingIncrease: (value) =>
          (dataTools.isNumber(value) && value >= 0) ||
          'Positive number expected'
      },

      firstBoundsIndex: 1,

      inputs: {
        name: this.getDefaultValue('name'),
        type: this.getDefaultValue('type'),
        geometriesBounds: [],
        optimizationGoal: this.getDefaultValue('optimizationGoal'),
        customOptimizationParameters: this.getDefaultValue(
          'customOptimizationParameters'
        ),
        lambda: this.getDefaultValue('lambda'),
        mu: this.getDefaultValue('mu'),
        mutationProbability: this.getDefaultValue('mutationProbability'),
        maximumPhenotypeAge: this.getDefaultValue('maximumPhenotypeAge'),
        steadyFitnessNumber: this.getDefaultValue('steadyFitnessNumber'),
        maximumDuration: this.getDefaultValue('maximumDuration'),
        maximumGenerations: this.getDefaultValue('maximumGenerations'),
        populationSize: this.getDefaultValue('populationSize'),
        description: this.getDefaultValue('description'),
        initialConstellation: null,
        zoneOfInterest: null,
        simulationDate: this.getDefaultValue('simulationDate'),
        layout: this.getDefaultValue('layout'), // to save the dashboard, should be optional in fieldsdesscription to be automatically copied
        deltaVMax: this.getDefaultValue('deltaVMax'),
        maneuverDuration: this.getDefaultValue('maneuverDuration'),
        numberOfSpacecraftCostWeight: this.getDefaultValue(
          'numberOfSpacecraftCostWeight'
        ),
        numberOfPlanesCostWeight: this.getDefaultValue(
          'numberOfPlanesCostWeight'
        ),
        maxPointRevisitTimeCostWeight: this.getDefaultValue(
          'maxPointRevisitTimeCostWeight'
        ),
        avgPointRevisitTimeCostWeight: this.getDefaultValue(
          'avgPointRevisitTimeCostWeight'
        ),
        semiMajorAxisCostWeight: this.getDefaultValue(
          'semiMajorAxisCostWeight'
        ),
        maxAllowedPointRevisitTime: this.getDefaultValue(
          'maxAllowedPointRevisitTime'
        ),
        reconfigurationDeltaVNeeded: this.getDefaultValue(
          'reconfigurationDeltaVNeeded'
        ),
        sunLightConsidered: this.getDefaultValue('sunLightConsidered'),
        sunZenithAngle: this.getDefaultValue('sunZenithAngle'),
        filterRatio: this.getDefaultValue('filterRatio'),
        id: ''
      }
    }
  },

  watch: {
    'inputs.initialConstellation': {
      handler(initialConstellation) {
        if (initialConstellation) {
          this.setBoundsTable()
        }
      }
    }
  },

  methods: {
    ...mapActions(['setCurrentMission']),

    requestComputationConstellationOptimizationHandler() {
      this.onSave()
    },
    copyMissionHandler(mission) {
      this.copyMission(mission)
    },
    createMissionHandler(mission) {
      this.createMission(mission)
    },
    currentMissionUpdatedHandler() {
      this.refreshForm()
    },

    refreshTable() {},

    async refreshReferences() {
      await this.refreshConstellations()
      await this.refreshZoneOfInterests()
    },

    convertUnits(items) {
      for (let i = 0; i < items.length; i++) {
        for (const key in items[i]) {
          if (
            key === 'negativeDeltaAltitude' ||
            key === 'positiveDeltaAltitude'
          ) {
            items[i][key] = dataTools.convertFromSi(
              'distance',
              items[i][key],
              'km'
            )
          } else if (
            key === 'negativeDeltaInclination' ||
            key === 'positiveDeltaInclination' ||
            key === 'positiveRaanShift' ||
            key === 'negativeRaanShift' ||
            key === 'positiveDeltaInterPlanePhasing' ||
            key === 'negativeDeltaInterPlanePhasing'
          ) {
            items[i][key] = dataTools.convertFromSi(
              'angle',
              items[i][key],
              'deg'
            )
          }
        }
      }
      return items
    },

    setBoundsTable() {
      if (this.inputs.geometriesBounds == null) {
        this.inputs.geometriesBounds = []
        for (
          let i = 0;
          i <
          this.inputs.initialConstellation.homogeneousConstellationGeometries
            .length;
          i++
        ) {
          let newGeometryBounds = {
            positiveDeltaNumberOfSpacecraftsPerPlane: 0,
            negativeDeltaNumberOfSpacecraftsPerPlane: 0,
            positiveDeltaNumberOfPlanes: 0,
            negativeDeltaNumberOfPlanes: 0,
            positiveDeltaAltitude: 0,
            negativeDeltaAltitude: 0,
            positiveDeltaInclination: 0,
            negativeDeltaInclination: 0,
            positiveRaanShift: 0,
            negativeRaanShift: 0,
            positiveDeltaInterPlanePhasing: 0,
            negativeDeltaInterPlanePhasing: 0
          }
          this.inputs.geometriesBounds.push(newGeometryBounds)
        }
      } else {
        let newGeometriesBounds = []
        for (
          let i = 0;
          i <
          this.inputs.initialConstellation.homogeneousConstellationGeometries
            .length;
          i++
        ) {
          if (i < this.inputs.geometriesBounds.length) {
            newGeometriesBounds.push(this.inputs.geometriesBounds[i])
          } else {
            let newGeometryBounds = {
              positiveDeltaNumberOfSpacecraftsPerPlane: 0,
              negativeDeltaNumberOfSpacecraftsPerPlane: 0,
              positiveDeltaNumberOfPlanes: 0,
              negativeDeltaNumberOfPlanes: 0,
              positiveDeltaAltitude: 0,
              negativeDeltaAltitude: 0,
              positiveDeltaInclination: 0,
              negativeDeltaInclination: 0,
              positiveRaanShift: 0,
              negativeRaanShift: 0,
              positiveDeltaInterPlanePhasing: 0,
              negativeDeltaInterPlanePhasing: 0
            }
            newGeometriesBounds.push(newGeometryBounds)
          }
        }
        this.inputs.geometriesBounds = newGeometriesBounds
      }
    },

    displayGeometryName(row) {
      return this.inputs.initialConstellation
        .homogeneousConstellationGeometries[row.index].name
    },

    hasOnlyOnePlane(index) {
      return (
        this.inputs.initialConstellation.homogeneousConstellationGeometries[
          index
        ].numberOfPlanes === 1
      )
    },

    getRequiredPropertiesList(instance) {
      if (Object.keys(instance).includes('positiveDeltaAltitude')) {
        // TODO workaround to be improved
        return dataTools.getPropertiesList(
          fieldsDescription['ConstellationOptimisationGeometryVariablesBounds'],
          null,
          'required'
        )
      }
      let objectType = this.getCurrentFormType()
      let missionType = this.getMissionType()
      return dataTools.getPropertiesList(
        fieldsDescription[objectType],
        missionType,
        'required'
      )
    },

    getOptionalPropertiesList(instance) {
      let missionType = this.getMissionType(instance)
      let objectType = this.getCurrentFormType()
      return dataTools.getPropertiesList(
        fieldsDescription[objectType],
        missionType,
        'optional'
      )
    },

    getMissionType() {
      let type = {
        optimizationGoal: this.inputs.optimizationGoal
      }
      return type
    },
    updateGroundSegmentSelection(fieldChanged, otherField) {
      // TODO not working : click on the checkbox or the label result in this funtion being called before or after the update
      if (
        this.inputs[fieldChanged] === true &&
        this.inputs[otherField] === true
      ) {
        this.inputs[otherField] = false
      }
    },

    copyMission(mission) {
      if (mission && mission.typeName === this.getCurrentFormType()) {
        this.copy(mission)
        this.sendFormToServer()
      }
    },

    refreshForm() {
      if (
        this.currentMission != null &&
        this.currentMission.typeName === this.getCurrentFormType()
      ) {
        if (this.currentMission.id !== this.inputs.id) {
          // different mission reload completely the form
          this.edit(this.currentMission, 0)
          this.convertUnits(this.inputs.geometriesBounds)
        } else {
          // reloading the current mission
          // only refresh the updated fields
          const fieldsToUpdate = [
            this.constellationsNotParametrics,
            this.groundStationsNotParametrics,
            this.zoneOfInterestsNotParametrics
          ]
          missionTools.updateAllReferences(this, fieldsToUpdate)
        }
      }
    },

    async refreshConstellations() {
      let self = this
      await this.$http
        .get(this.getAPI(`constellationdefinitions`))
        .then((response) => {
          self.constellationsNotParametrics = response.data
            .map((obj) => ({ value: obj, text: obj.displayedName }))
            .sort((a, b) =>
              a.text.toLowerCase() < b.text.toLowerCase() ? -1 : 1
            )
        })
        .catch((e) => {
          self.displayMessage(
            'Error getting list of constellations. ',
            e,
            'notification',
            'error'
          )
        })
    },

    onSave: function (evt) {
      this.inputs.saving = true
      this.$http
        .put(
          this.getCurrentAPI() + '/' + this.inputs.id,
          this.createObjectFromForm()
        )
        .then((response) => {
          this.inputs.saving = false
          this.$root.$emit('update-mission-list')
          this.$root.$emit('set-current-mission', response.data) // update fields and current mission
          // redirect to dashboard
          this.$router.push({
            path: '/constellationrevisitoptimizationdashboard'
          })
        })
        .catch((e) => {
          this.inputs.saving = false
          this.displayMessage(
            'Error creating ' + this.inputs.type + '. ',
            e,
            'notification',
            'error'
          )
        })
    },

    async refreshZoneOfInterests() {
      let self = this
      await this.$http
        .get(this.getAPI(`zoneofinterestdefinitions`))
        .then((response) => {
          self.zoneOfInterestsNotParametrics = response.data
            .map((obj) => ({ value: obj, text: obj.displayedName }))
            .sort((a, b) =>
              a.text.toLowerCase() < b.text.toLowerCase() ? -1 : 1
            )
        })
        .catch((e) => {
          self.displayMessage(
            'Error getting zone of interest. ',
            e,
            'notification',
            'error'
          )
        })
    },

    getRefList(param) {
      if (param === 'constellations') {
        return this.constellationsNotParametrics
      }
      if (param === 'zoneOfInterest') {
        return this.zoneOfInterestsNotParametrics
      }
    },

    getCurrentFormTitle() {
      return 'Constellation Optimization'
    },

    getCurrentFormType() {
      return 'ConstellationOptimizationRequest'
    },

    updateMissionFields(fields) {
      if (fields.typeName === this.getCurrentFormType()) {
        for (let field in fields) {
          this.inputs[field] = fields[field]
        }
      }
    },

    createMission(mission) {
      if (mission.typeName === this.getCurrentFormType()) {
        this.clearForm()
        this.updateMissionFields(mission)
        this.sendFormToServer()
      }
    },

    sendFormToServer() {
      this.inputs.saving = true
      this.$http
        .post(this.getCurrentAPI(), this.createObjectFromForm())
        .then((response) => {
          this.inputs.saving = false
          this.$root.$emit('set-current-mission', response.data)
        })
        .catch((e) => {
          this.inputs.saving = false
          this.displayMessage(
            'Error creating ' + this.inputs.type + '. ',
            e,
            'AnalyticalMissionErrorDisplay',
            'error'
          )
        })
    },

    addFieldsListToBaseObject(
      baseObject,
      fieldsList,
      parentObject = this.inputs
    ) {
      for (let field of fieldsList) {
        if (this.getPropertiesDescription()[field] != null) {
          let fieldType = this.getPropertiesDescription()[field].type
          if (
            fieldType === 'enum' ||
            fieldType === 'boolean' ||
            fieldType === 'date'
          ) {
            baseObject[field] = parentObject[field]
          } else if (fieldsDescription[fieldType] != null) {
            if (field === 'geometriesBounds') {
              baseObject[field] = []
              if (parentObject[field] != null) {
                // inner object to convert
                for (let item of parentObject[field]) {
                  let convertedItem = {}
                  for (let innerField in item) {
                    if (!fieldsDescription[fieldType].properties[innerField]) {
                      convertedItem[innerField] = item[innerField]
                    } else {
                      convertedItem[innerField] = dataTools.convertGui2si(
                        fieldsDescription[fieldType].properties[innerField]
                          .type,
                        item[innerField]
                      )
                    }
                  }
                  baseObject[field].push(convertedItem)
                }
              }
            } else {
              baseObject[field] = parentObject[field]
            }
          } else {
            baseObject[field] = dataTools.convertGui2si(
              this.getFieldType(field),
              parentObject[field]
            )
          }
        }
      }
      baseObject.constellations = parentObject.constellations
      return baseObject
    },

    clearLocalFields() {
      for (let field in this.getPropertiesDescription()) {
        if (this.inputs.hasOwnProperty(field)) {
          this.inputs[field] = this.getDefaultValue(field)
          let fieldType = this.getPropertiesDescription()[field].type
          if (dataDescription[fieldType] != null) {
            this.checkParametricValue(this.inputs, field)
          } else if (fieldsDescription[fieldType] != null) {
            this.checkParametricReference(this.inputs, field)
          }
        }
      }
      this.inputs.subMissions = []
    },

    copyLocalFields(item) {
      this.inputs.id = item.id
      this.copyFieldsToBaseObject(item, this.inputs)
    },

    addLocalFieldsFromForm(baseObject, fieldsList) {
      baseObject = this.addFieldsListToBaseObject(baseObject, fieldsList)
      baseObject.computationRequested = true
      return baseObject
    },

    copyFieldsToBaseObject(item, baseObject) {
      for (let field in this.getPropertiesDescription()) {
        if (item.hasOwnProperty(field)) {
          let fieldType = this.getPropertiesDescription()[field].type
          if (dataDescription[fieldType] !== undefined) {
            // parametric value
            baseObject[field] = dataTools.convertSi2gui(
              this.getFieldType(field),
              item[field]
            )
            this.checkParametricValue(baseObject, field)
          } else {
            baseObject[field] = item[field]
            if (fieldsDescription[fieldType] != null) {
              this.checkParametricReference(baseObject, field)
            }
          }
        }
      }
    }
  }
}
</script>
